<template>
  <div>
    <v-dialog v-model="showWindow" scrollable max-width="950px" persistent>
      <v-card :loading="!isFetchedProductImportInfo">
        <v-card-actions>
          <h3 class="pl-2">
            {{ $t('viewSettings.goods_export.task_import_info_status') }}
          </h3>
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="close"
          >
            <v-icon>fa-times</v-icon>
          </v-btn>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="pa-4">
          <vue-json-pretty :data="productImportInfo" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {
  name: "OzonSellerApiTaskImportInfo",
  components: {
    VueJsonPretty,
  },
  props: {
    task_id: {
      type: String
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    emptyParameters: {
      client_id: null,
      api_key: null,
    },
  }),
  methods: {
    close() {
      this.showWindow = false;
    }
  },
  computed: {
    isDisabledForm() {
      return (
        this.savingInProgress || !this.isFetched
      );
    },
    ...mapFields("ozon_seller_api", ["productImportInfo", "isFetchedProductImportInfo"]),
    showWindow: {
      get() {
        return this.show;
      },
      set() {
        this.$emit("hide");
        this.$refs.form.resetValidation();
      },
    },
  },
  watch: {
    show(to) {
      this.$store.dispatch("ozon_seller_api/getTaskImportInfo", this.task_id);
    },
  },
};
</script>

<style scoped></style>
